export default __webpack_public_path__ + "static/media/github.1a78f568.svg";